/**
 * @generated SignedSource<<75ac5fe45807377ad77c7105a2dd996e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type sprint_nativeIssueTable_SprintCellInternalOld_fieldRef$data = {
  readonly selectedSprintsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "sprint_nativeIssueTable_SprintCellInternalOld_fieldRef";
};
export type sprint_nativeIssueTable_SprintCellInternalOld_fieldRef$key = {
  readonly " $data"?: sprint_nativeIssueTable_SprintCellInternalOld_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"sprint_nativeIssueTable_SprintCellInternalOld_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "sprint_nativeIssueTable_SprintCellInternalOld_fieldRef",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSprintField"
};

(node as any).hash = "02a5a5467a90c8816d7f1ee9623768a7";

export default node;
